import previewRowUrl from './premiumPreviewRowComponent.html';

export default {
  templateUrl: previewRowUrl,
  controllerAs: 'ctrl',
  bindings: {
    image: '<',
    width: '@?',
    isReversed: '<?',
    title: '@',
    description: '@',
  },
};
